import Tag from '../src/Tag';
export default Tag;
